export const DISMISS_ICON_BUTTON = "size-9 sm:size-8";
